module.exports = __webpack_public_path__ + "img/slide_2.c2dd6fa2.jpg";